export default "__VITE_ASSET__b2c7e6b6__"